import React, {useContext} from 'react';
import ThirdPartyBankMaster from './ThirdPartyBankMaster';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import { useGetPermissions } from 'layouts/customHook';

const ThirdPartyBankAccMaster = () => {
   const userPermissions = useGetPermissions("thirdPartyBankAccounts");
    return (
        userPermissions
            ? <ThirdPartyBankMaster userPermissions={userPermissions}/>
            : <PermisionDenied />
    );
}

export default ThirdPartyBankAccMaster;